import activityTracker from '@/utils/activityTracker';
import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';
import { Env } from '../../config/env';
import { userInfoStore } from '../../models';
import arms from '@/utils/arms';

export const SUCCESS_CODE = 20000;

const handleTokenDisabled = () => {
  // 闲置重登弹窗打开期间（tracker 暂停态）：不清 token、不跳转，
  // 后台轮询请求的 401 静默失败，避免抢在弹窗前硬跳登录页
  if (activityTracker.isPaused()) return;
  // logout 内部已清 store 状态 + localStorage（TMS_TOKEN_KEY / TMS_ORGANIZATION_ID_KEY）
  userInfoStore.logout();
  location.replace('/');
};

export const api: AxiosInstance = axios.create({
  baseURL: Env.apiUrl,
  timeout: 1000 * 60 * 10, // 10min
});

// 扩展 axios 配置：noAuth 为 true 时该请求不携带 token。
// 用于登录接口——调用时 store 里可能还留着已过期的旧 token，
// 带上去会导致后端按无效会话拒绝（如闲置重登弹窗里调用的 /identity/authenticate）
declare module 'axios' {
  export interface AxiosRequestConfig {
    noAuth?: boolean;
  }
}

/* 请求拦截器 */
api.interceptors.request.use(
  (config) => {
    (config.headers as AxiosRequestHeaders).Versionnumber = Env.release;
    if (userInfoStore.token && !config.noAuth) {
      (config.headers as AxiosRequestHeaders).Authorization = userInfoStore.token;
    }
    if (userInfoStore.organizationId) {
      (config.headers as AxiosRequestHeaders).OrganizationId = userInfoStore.organizationId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
/* 响应拦截器 */
api.interceptors.response.use(
  (response) => {
    if (response.data.Code && response.data.Code !== 20000) {
      if (response.data.Code === 54018) {
        return response.data;
      } else if (response.data.Code === 54042) {
        return Promise.reject(response.data);
      } else if (response.data.Code === 59601) {
        return Promise.reject(response.data);
      } else if (response.data.Code === 40100) {
        // 会话过期（如关闭全部标签页超过闲置时长，后端会话缓存已清除），
        // 后端以 HTTP 200 + 业务码返回，与 HTTP 401 同等处理：清 token 回登录页
        handleTokenDisabled();
      } else {
        return Promise.reject(new Error(response.data.Message));
      }
    }
    // return response.data.Data !== undefined && response.data.Data !== null ? response.data : { Data: response.data };
    return response.data;
  },
  (error) => {
    // if (error.response && error.response.data) {
    //   return Promise.reject(new Error(error.response.data));
    // }
    if (error.response?.status === 401) {
      handleTokenDisabled();
    }
    arms.error(error);
    return Promise.reject(error);
  },
);
